import React from "react";
import get from "lodash/get";
import ExerciseLibraryComponent from "../../dashboard/settings/ExerciseLibraryComponent";

function ExerciseLibrary(props, { locals }) {
  const {
    query,
    query: { type },
    activeUser,
    athlete,
    fromMetric,
    withWeight,
  } = locals;
  const { organizationCoachId } = props;
  let primary = query.primary;

  const secondaries = get(athlete, `exerciseLibrary.${primary}`) || [];

  const primaryRepMax = withWeight(
    activeUser.units === "imperial"
      ? fromMetric(athlete.repMaximums[primary])
      : athlete.repMaximums[primary],
    activeUser.units
  );
  return (
    <ExerciseLibraryComponent
      type={type}
      primary={primary}
      primaryRepMax={primaryRepMax}
      secondaries={secondaries}
      withWeight={withWeight}
      fromMetric={fromMetric}
      activeUser={activeUser}
      athlete={athlete}
      locals={locals}
      query={query}
      organizationCoachId={organizationCoachId}
    />
  );
}

export default ExerciseLibrary;
